import React from 'react';

const Panel = ({ title, subtitle, actions, children, className = '', compact = false, ...props }) => (
  <section className={`panel ${compact ? 'panel-compact' : ''} ${className}`.trim()} {...props}>
    {(title || subtitle || actions) && (
      <div className="panel-header">
        <div>
          {title && <h2 className="panel-title">{title}</h2>}
          {subtitle && <p className="panel-subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="panel-actions">{actions}</div>}
      </div>
    )}
    <div className="panel-body">{children}</div>
  </section>
);

export default Panel;
